module.exports = __webpack_public_path__ + "img/9.a37bc58b.png";